import React, {FunctionComponent, useContext, useState} from 'react'
import {IClientGoal} from "../../../../app/models/clientGoals";
import {Grid, Header, Icon, Label, Loader, Segment} from "semantic-ui-react";
import DateTimePickerWithShortcuts from "../../../commom/date/DateTimePickerWithShortcuts";
import moment from "moment";
import ShowMoreButton from "../../../commom/buttons/ShowMoreButton";
import {RootStoreContext} from "../../../../app/stores/rootStore";
import {dateToLocaleStringOrAccentYesterdayTodayAndTomorrow} from "../../../../app/common/util/date";

interface OwnProps {
    clientGoal: IClientGoal
}

type Props = OwnProps

const ClientGoalDatesCellCompletedDate: FunctionComponent<Props> = ({clientGoal}) => {
    const rootStore = useContext(RootStoreContext)

    const {updateDate} = rootStore.clientGoalsStore

    const [editMode, setEditMode] = useState(false)
    const [showEditIcon, setShowEditIcon] = useState(false)


    return <>
        {editMode ?
            <Segment.Group compact>
                <Segment attached='bottom' style={{padding: 5}}>

                    <Label
                        basic
                        style={{border: 0}}
                        attached='top right'>
                        <Loader size='mini' inline active={clientGoal.flags?.updating}/>
                        <Icon
                            style={{cursor: 'pointer'}}
                            name='x'
                            circular
                            size='small'
                            onClick={() => setEditMode(false)}
                        />
                    </Label>
                    <DateTimePickerWithShortcuts
                        placeholder='Datum završetka'
                        shortcuts={{
                            today: true,
                            tomorrow: true,
                            nextWeek: true
                        }}
                        vertical
                        disabled={clientGoal.flags?.updating}
                        date={clientGoal.completedDate ? moment(clientGoal.completedDate) : null}
                        onChange={date =>
                            updateDate(clientGoal.id, 'completed', date ? date.format('YYYY-MM-DD') : null)}/>
                </Segment>
            </Segment.Group> :
            <div>
                {clientGoal.completedDate ? <Header as='h3'>
                    <Header.Content
                        onMouseEnter={() => setShowEditIcon(true)}
                        onMouseLeave={() => setShowEditIcon(false)}
                    >
                        <Header.Subheader>Najkasnije</Header.Subheader>
                        {moment(clientGoal.completedDate).isBetween(moment().subtract(2, 'day'), moment().add(2, 'day'), 'day') ?
                            <Header as='h4' color='blue' content={dateToLocaleStringOrAccentYesterdayTodayAndTomorrow(clientGoal.completedDate)} /> :
                            <span>{moment(clientGoal.completedDate).format('l')}</span>}{' '}{showEditIcon && <Icon
                        link
                        name='pencil alternate'
                        onClick={() => setEditMode(true)}
                        color='orange'/>}
                    </Header.Content>
                </Header> : <Grid>
                    <Grid.Column textAlign='center' width={16}>
                        <ShowMoreButton content='Dodaj datum završetka' onClick={() => setEditMode(true)}/>
                    </Grid.Column>
                </Grid>}
            </div>}
    </>
}

export default ClientGoalDatesCellCompletedDate
